export const WEIGHT_OK_COLOR = "#0f766e";
export const WEIGHT_GAIN_COLOR = "#dc2626";

export const getWeightTrendColors = (values) => {
  let previousValue = null;

  return values.map((value) => {
    const numericValue = value === null || value === undefined || value === "" ? null : Number(value);
    if (!Number.isFinite(numericValue)) {
      return WEIGHT_OK_COLOR;
    }

    const color = previousValue !== null && numericValue > previousValue ? WEIGHT_GAIN_COLOR : WEIGHT_OK_COLOR;
    previousValue = numericValue;
    return color;
  });
};
